import { render, staticRenderFns } from "./MenuName.vue?vue&type=template&id=65fdfe7b&scoped=true"
import script from "./MenuName.vue?vue&type=script&lang=ts"
export * from "./MenuName.vue?vue&type=script&lang=ts"
import style0 from "./MenuName.vue?vue&type=style&index=0&id=65fdfe7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fdfe7b",
  null
  
)

export default component.exports